<template>
  <div style="padding: 0; margin: 0; height: 100%;">
    <div v-loading="loading" element-loading-text="加载中..." class="app-container">
      <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
        <template slot="header">
          <el-row :gutter="10" class="filter-container">
            <el-col :xs="24" :sm="6">
              <el-input v-model="queryParams.keyword" class="filter-item" placeholder="用户昵称、手机号或分享码" clearable />
            </el-col>
            <el-col :xs="24" :sm="3">
              <el-select v-model="queryParams.grade" class="filter-item" placeholder="用户身份" clearable>
                <el-option v-for="(item, index) in memberLevel" :key="index" :label="item.levelName" :value="item.id" />
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="3">
              <el-select v-model="queryParams.consumerLevel" class="filter-item" placeholder="消费等级" clearable>
                <el-option label="非消费者" :value="0" />
                <el-option label="消费者" :value="1" />
                <el-option label="消费商" :value="2" />
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="3">
              <el-select v-model="queryParams.partnership" class="filter-item" placeholder="合伙人身份" clearable>
                <el-option label="合作商" :value="3" />
                <el-option label="联盟企业" :value="4" />
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="3">
              <el-select v-model="queryParams.status" class="filter-item" placeholder="状态" clearable>
                <el-option label="禁用" :value="0" />
                <el-option label="启用" :value="1" />
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
            </el-col>
          </el-row>
        </template>

        <el-table v-sticky-header stripe fit highlight-current-row :data="list" header-cell-class-name="table-header-cell">
          <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell">
            <template slot-scope="scope">
              <span>{{ (scope.$index + 1) + (queryParams.page - 1) * queryParams.limit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用户昵称" prop="nickName" min-width="120">
            <template slot-scope="{row}">{{ row.nickName | filterMemberName }}</template>
          </el-table-column>
          <el-table-column label="手机号" prop="mobile" min-width="120" />
          <el-table-column label="分享码" prop="shareCode" min-width="80" />
          <el-table-column label="身份等级" prop="gradeName" align="center" width="100" />
          <el-table-column label="消费等级" prop="consumerName" align="center" width="100" />
          <el-table-column label="合伙人身份" align="center" width="100">
            <template slot-scope="{row}">{{ row.partnership | filterPartnership }}</template>
          </el-table-column>
          <el-table-column label="邀请人" prop="inviterName" min-width="120" />
          <el-table-column label="注册时间" prop="createTime" min-width="150" />
          <el-table-column align="center" width="80" fixed="right">
            <template slot-scope="{row}">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  操作<i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="handleDetail(row.id)">用户详情</el-dropdown-item>
                  <el-dropdown-item divided @click.native="handleTransfer(row)">给用户转账</el-dropdown-item>
                  <el-dropdown-item divided @click.native="handleInviter(row)">更改推荐人</el-dropdown-item>
                  <el-dropdown-item divided @click.native="handlePartnership(row)">更改合伙人身份</el-dropdown-item>
                  <el-dropdown-item v-if="row.partnership" @click.native="cancelPartner(row.id)">取消合伙人身份</el-dropdown-item>
                  <el-dropdown-item divided @click.native="handleShopEmployee(row)">商家店员设置</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchData" />
      </el-card>
    </div>

    <member-detail v-if="detailDialog" :show.sync="detailDialog" :member-id="memberId" />
    <user-transfer v-if="transferDialog" :member-info="detail" :show.sync="transferDialog" />
    <user-partner v-if="partnerDialog" v-model="detail" :show.sync="partnerDialog" @submit="bindChangePartner" />
    <employee-detail v-if="employeeDialog" :show.sync="employeeDialog" :member-id="memberId" :user-info="detail" :stores="storeList" />
  </div>
</template>

<script>
import { getStoreList } from '@/api/store'
import { StickyHeader } from '@cell-x/el-table-sticky'
import { getMemberList, changePartnership } from '@/api/member'

export default {
  name: 'MemberIndex',
  components: {
    memberDetail: () => import('./detail'),
    Pagination: () => import('@/components/Pagination'),
    UserPartner: () => import('./components/user-partner'),
    UserTransfer: () => import('./components/user-transfer'),
    EmployeeDetail: () => import('../store/staff/detail')
  },
  filters: {
    filterMemberName: (memberName) => {
      return memberName || '慧生活用户'
    },
    filterPartnership: (level) => {
      return level === 3 ? '合作商' : (level === 4 ? '联盟企业' : '')
    }
  },
  directives: {
    StickyHeader: new StickyHeader({ offsetTop: 0, offsetBottom: 0 }).init()
  },
  data() {
    return {
      list: [],
      total: 0,
      detail: {},
      storeList: [],
      loading: false,
      memberLevel: this.$store.getters.memberLevels,
      queryParams: {
        keyword: '',
        grade: '',
        consumerLevel: '',
        partnership: '',
        status: '',
        page: 1,
        limit: 20
      },
      memberId: '',
      detailDialog: false,
      partnerDialog: false,
      transferDialog: false,
      employeeDialog: false,
      partnerRules: {
        partnership: [{ required: true, message: '请选择合伙人身份', trigger: 'change' }]
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      this.loading = true
      Promise.all([getStoreList({ status: 1, state: 1 }), getMemberList(this.queryParams)]).then(([stores, response]) => {
        this.total = response.total
        this.$util.delay().then(() => {
          this.list = response.records
          this.storeList = stores
          this.loading = false
        })
      }).catch(() => { this.loading = false })
    },
    handleFilter() {
      this.queryParams.page = 1
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      getMemberList(this.queryParams).then(response => {
        this.total = response.total
        this.$util.delay().then(() => {
          this.list = response.records
          this.loading = false
        })
      }).catch(() => { this.loading = false })
    },
    handleDetail(memberId) {
      this.loading = true
      this.memberId = memberId
      this.$util.delay().then(() => {
        this.detailDialog = true
        this.loading = false
      })
    },
    detailClose() {
      // this.partnerDialog = false
      this.detailDialog = false
      this.memberId = undefined
      this.detail = {}
    },
    handleTransfer(row) {
      this.detail = Object.assign({}, row)
      this.transferDialog = true
    },
    handleInviter(row) {
    },
    handlePartnership(row) {
      this.detail = Object.assign({}, row, { partnership: row.partnership === 0 ? '' : row.partnership })
      this.partnerDialog = true
    },
    bindChangePartner() {
      this.$message.success('更改合伙人身份成功')
      this.$util.delay().then(() => {
        this.list.forEach((row, index) => {
          if (row.id === this.detail.id) {
            this.list.splice(index, 1, this.detail)
          }
        })
      })
    },
    cancelPartner(memberId) {
      this.$confirm('确定要取消该合伙人身份吗？', '温馨提示', { type: 'warning' }).then(() => {
        const data = { id: memberId, partnership: 0 }
        changePartnership(data).then(response => {
          if (response) {
            this.$message.success('取消合伙人身份成功')
            this.$util.delay().then(() => {
              this.list.forEach((row, index) => {
                if (row.id === memberId) {
                  row.partnership = 0
                  this.list.splice(index, 1, row)
                }
              })
            })
          }
        })
      })
    },
    handleShopEmployee(row) {
      this.loading = true
      this.detail = row
      this.memberId = row.id
      this.$util.delay().then(() => {
        this.employeeDialog = true
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-card__header {
    padding-bottom: 0;
  }
}
</style>
